var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Từ "+_vm._s(_vm.from)+" -> "+_vm._s(_vm.to)+" trong tổng "+_vm._s(_vm.pagination.total)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }